import { RecentActivities } from '@/interfaces/dashboard/recent-activities';
import { State } from '@/store/login/reducer';
import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';

@Component({
  selector: 'app-modal-detail-activities',
  templateUrl: './modal-detail-activities.component.html',
  styleUrls: ['./modal-detail-activities.component.css'],
})
export class ModalDetailActivitiesComponent implements OnInit {
  @Input() visible = false;
  @Output() handleClose: EventEmitter<void> = new EventEmitter();
  @Input() dataToShow: Partial<RecentActivities> = {};

  userData?: State;

  // to-do : traerme tipo de actividad
  // to-do traerme  numero ??  id  liciencia  o  id solicitud  o id registro
  // to-do traerme  detalle de  usuario
  // infraccion  (detalle  licencia usuario - detalle de infraccion - responsable - quien reporta)
  // licencia   ( usuario conductor  - detalle de asset- detalles de equipo- vigencia del documento )

  constructor(private store: Store<StoreState>) {
    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.userData = userData;
      },
    });
  }

  ngOnInit(): void {

  }

}
